import React, { useMemo, useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Modal, Row, Dropdown, ProgressBar, Form, Button, Badge } from "react-bootstrap";
import Plyr from "plyr-react"
import "plyr-react/plyr.css"
import api from '../services/api'
import { toast } from 'react-toastify'
import { set_handle_posts } from '../store/setting/actions'
import { formatDistanceToNow, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FaCheck } from 'react-icons/fa'
import { IoClose } from "react-icons/io5"
import Cookies from 'js-cookie'
import DOMPurify from 'dompurify'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../components/Post/style-carousel.css';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize';
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from "quill-mention";

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
Quill.register('modules/imageResize', ImageResize);

const fetchPostMedia = async (postId) => {
    try {
        const response = await api.get(`/api/post/${postId}/media`);
        return response.data.media || [];
    } catch (error) {
        console.error(`Erro ao carregar mídia do post ${postId}`, error);
        return [];
    }
};

const ShareOffcanvasNew = (props) => {

    const dispatch = useDispatch()
    const customId = 'success-toast-id'
    const [text, setText] = useState('')
    const [showSpinner, setShowSpinner] = useState(false)
    const [privacy, setPrivacy] = useState('public')
    const handlePosts = useSelector((state) => state.setting.setting.handle_posts)
    const logged_user = Cookies.get('userId')
    const [selectedOption, setSelectedOption] = useState(null);
    const [totalVotes, setTotalVotes] = useState(0);
    const [hasVoted, setHasVoted] = useState(false);
    const [pollDetails, setPollDetails] = useState([]);
    const [creator, setCreator] = useState([]);
    const [error, setError] = useState(null);
    const [voting, setVoting] = useState(false);
    const [formattedStartDate, setFormattedStartDate] = useState({ date: '', time: '' });
    const [formattedEndDate, setFormattedEndDate] = useState({ date: '', time: '' });
    const [isLoading, setIsLoading] = useState(true)
    const poll_id = props.poll_id
    const live_id = props.live_id
    const live_name = props.live_name
    const live_iframe = props.live_iframe
    const vimeoIframeRef = props.vimeoIframeRef
    const quiz_id = props.quiz_id
    const event_id = props.event_id ?? ''
    const event_place = props.event_place
    const event_external_link = props.event_external_link
    const event_start_date = props.event_start_date
    const event_end_date = props.event_end_date
    const options = props.options
    const right_answer = props.right_answer
    const user_answer = props.user_answer
    const [answered, setAnswered] = useState(user_answer ? true : false)
    const [isRight, setIsRight] = useState(user_answer === right_answer ? true : false)
    const [selectedQuizOption, setSelectedQuizOption] = useState('')
    const [showSpinnerQuizAnswer, setShowSpinnerQuizAnswer] = useState(false)
    const post_id = props.post_id
    const share_id = props.share_id
    const share_posts = props.share_posts
    const [showScheduleModal, setShowScheduleModal] = useState(false)
    const [schedules, setSchedules] = useState([])
    const [medias, setMedia] = useState([]);
    const [shareMedia, setShareMedia] = useState([]);
    const lastPostIdRef = useRef(null);
    const lastSharePostIdRef = useRef(null);

    const getSchedule = async () => {
        try {
            const response = await api.get(`/api/eventSchedules/${event_id}`)
            setSchedules(response.data.schedule)
        } catch (error) {
            console.error('Erro')
            toast.error('Erro ao carregar programaação do evento.', { autoClose: 1000 })
        }
    }

    useEffect(() => {
        if (event_id) {
            getSchedule()
        }
    }, []);

    function parsePostText(texto) {
        if (texto) {
            return texto.replace(/\{@}\[([^\]]+)\]\((\d+)\)/g, '<a href="/users/profile/$2">@$1</a>');
        } else {
            return texto;
        }
    }

    function formatDate(dataString) {
        const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
        const mesesAno = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

        const data = new Date(dataString.replace(" ", "T"));

        const diaSemana = diasSemana[data.getDay()];
        const diaMes = data.getDate();
        const mes = mesesAno[data.getMonth()];
        const hora = data.getHours().toString().padStart(2, '0');
        const minutos = data.getMinutes().toString().padStart(2, '0');

        return `${diaSemana}, ${diaMes} de ${mes} às ${hora}:${minutos}`;
    }

    const handleDateField = (date) => {
        if (date && typeof date === 'string' && date.trim() !== '') {
            const [year, month, day] = date.split('-');
            const localDate = new Date(year, month - 1, day);
            return localDate.toLocaleDateString();
        }
        return '';
    };

    const formatScheduleField = (dateString, timeString) => {
        const formattedDate = handleDateField(dateString);
        const [hours, minutes] = timeString.split(':');
        const formattedTime = `${hours}:${minutes}`;

        return (
            <>
                <div className='d-flex align-items-center gap-1'>
                    <span className="material-symbols-outlined fs-5">calendar_today</span> {formattedDate}
                </div>
                <div className='d-flex align-items-center gap-1'>
                    <span className="material-symbols-outlined fs-5">schedule</span> {formattedTime}
                </div>
            </>
        );
    };

    const answerQuestion = async (answer) => {
        setShowSpinnerQuizAnswer(true)

        if (answer === '') {
            setShowSpinnerQuizAnswer(false)

            toast.error('Selecione uma alternativa para responder o quiz', { autoClose: 3000 })
        } else {
            const formData = new FormData()
            formData.append('post_id', post_id)
            formData.append('answer', answer)

            await api.post(`/api/quiz/answer`, formData).then((res) => {
                setSelectedQuizOption('')
                setShowSpinnerQuizAnswer(false)
                setIsRight(res.data.is_right)
                setAnswered(true)

                toast.success('Quiz respondido com sucesso', { autoClose: 3000 })
            }).catch(err => {
                setShowSpinnerQuizAnswer(false)
                toast.error('Erro ao responder quiz', { autoClose: 3000 })
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setShowSpinner(true)

        if (text === '') {
            setShowSpinner(false)
            toast.error('Por favor escreva um texto para a postagem.', { autoClose: 3000 })
        } else {
            const formData = new FormData()
            formData.append('text', text)
            formData.append('privacy', privacy)
            formData.append('post_id', props.post_id)
            formData.append('logged_user', logged_user)

            if (props.group_id) formData.append('group_id', props.group_id)

            if (props.poll_id) formData.append('poll_id', props.poll_id)

            if (props.quiz_id) formData.append('quiz_id', props.quiz_id)

            if (props.live_id) formData.append('live_id', props.live_id)

            if (props.live_iframe) formData.append('live_iframe', props.live_iframe)

            if (props.event_id) formData.append('event_id', props.event_id)


            await api.post(`/api/posts/share/store`, formData).then(() => {
                setShowSpinner(false)
                setText('')

                dispatch(set_handle_posts(!handlePosts))
                props.onHide()

                toast.success('Postagem criada com sucesso!', {
                    toastId: customId,
                    autoClose: 300,
                })
            }).catch(err => {
                setShowSpinner(false)
                toast.error('Erro ao publicar postagem.', { autoClose: 3000 })
            })
        }
    }

    const playerRef = useRef(null);
    const plyrProps = useMemo(() => ({
        source: {
            type: "video",
            sources: [
                {
                    src: props.new_media,
                    type: "video/mp4",
                }
            ]
        }
    }), [props.new_media]);

    const sanitizedText = DOMPurify.sanitize(props.text);
    const formatDateAndTime = (datetime) => {
        if (!datetime) return { date: '', time: '' };

        const dateObj = new Date(datetime);

        // Formatar a data no formato DD/MM/YY
        const date = dateObj.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });

        // Formatar a hora no formato HH:mm
        const time = dateObj.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
        });

        return { date, time };
    };

    const fetchPollDetails = async () => {
        try {
            const response = await api.get(`/api/polls/${poll_id}`);
            const { hasVoted } = response.data;
            setPollDetails(response.data.poll);
            setCreator(response.data.poll.creator)


            // Calcular o total de votos
            const totalVotes = response.data.poll.options.reduce(
                (acc, option) => acc + option.votes,
                0
            );
            setTotalVotes(totalVotes);

            setHasVoted(hasVoted);

            // Formatar start_date e end_date
            const startDateFormatted = formatDateAndTime(response.data.poll.start_date);
            const endDateFormatted = formatDateAndTime(response.data.poll.end_date);

            setFormattedStartDate(startDateFormatted);
            setFormattedEndDate(endDateFormatted);


        } catch (err) {
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (poll_id) {
            fetchPollDetails();

            const interval = setInterval(() => {
                fetchPollDetails();
            }, 300000)

            return () => clearInterval(interval);
        }

    }, [poll_id]);


    const handleVote = async () => {
        if (!selectedOption) {
            alert('Por favor, selecione uma opção.');
            return;
        }

        setVoting(true);
        try {
            const response = await api.post(`/api/polls/${poll_id}/vote`, {
                option_id: selectedOption,
            });

            if (response.status === 200 && response.data.message) {
                toast.success(response.data.message);
                fetchPollDetails()
                setHasVoted(true)
            } if (response.status === 202 && response.data.message) {
                toast.warning(response.data.message);
            }


        } catch (err) {
            console.log(err)
            toast.error('Erro ao registrar voto!')
        } finally {
            setVoting(false);
        }
    };

    const handleOptionChange = (event) => {
        setSelectedOption(parseInt(event.target.value, 10));
    };


    const playerRefShareVideo = useRef(null);

    const plyrPropsShare = useMemo(() => ({
        source: {
            type: "video",
            sources: [
                {
                    src: share_posts ? share_posts.video : '',
                    type: "video/mp4",
                }
            ]
        }
    }), [share_posts ? share_posts.video : '']);

    useEffect(() => {
        let isMounted = true;

        const loadMedia = async () => {
            if (post_id && lastPostIdRef.current !== post_id) {
                const postMedia = await fetchPostMedia(post_id);
                if (isMounted) {
                    setMedia(postMedia);
                    lastPostIdRef.current = post_id;
                }
            }

            const sharedId = share_posts?.id;
            if (share_id && sharedId && lastSharePostIdRef.current !== sharedId) {
                const sharedPostMedia = await fetchPostMedia(sharedId);
                if (isMounted) {
                    setShareMedia(sharedPostMedia);
                    lastSharePostIdRef.current = sharedId;
                }
            }
        };

        loadMedia();

        return () => {
            isMounted = false;
        };
    }, [post_id, share_id, share_posts?.id]);

    const [currentSlide, setCurrentSlide] = useState(0);
    const totalShareSlides = shareMedia.length;
    const totalSlides = medias.length;

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        initialSlide: currentSlide
    };

    const MAX_INDICATORS = Math.max(medias.length, shareMedia.length);

    const getVisibleIndicators = (total, current) => {
        if (total <= MAX_INDICATORS) return Array.from({ length: total }, (_, i) => i);

        const halfMax = Math.floor(MAX_INDICATORS / 2);
        let start = Math.max(0, current - halfMax);
        let end = Math.min(total, start + MAX_INDICATORS);

        if (end - start < MAX_INDICATORS) start = Math.max(0, end - MAX_INDICATORS);

        return Array.from({ length: end - start }, (_, i) => i + start);
    };

    const getIndicatorStyle = (index, current) => {
        const distance = Math.abs(current - index);

        if (distance === 0) return 'large';
        if (distance === 1) return 'medium';
        if (distance === 2) return 'small';
        return 'tiny';
    };

    const [quillReady, setQuillReady] = useState(false);
    const editorRef = useRef(null);
    const quillInstance = useRef(null);
    const [newMedia, setNewMedia] = useState([]);

    const removeImages = () => {
        const images = quillInstance.current.root.querySelectorAll('img');
        images.forEach(img => img.remove());
    };

    function convertMentionsToCustomFormat(html) {
        const div = document.createElement('div');
        div.innerHTML = html;

        const mentions = div.querySelectorAll('span.mention');

        mentions.forEach(span => {
            const name = span.dataset.value;
            const id = span.dataset.id;

            const formatted = `{@}[${name}](${id})`;

            const textNode = document.createTextNode(formatted);
            span.parentNode.replaceChild(textNode, span);
        });

        return div.innerHTML;
    }

    useEffect(() => {
        if (props.show && editorRef.current && !quillInstance.current) {
            quillInstance.current = new Quill(editorRef.current, {
                theme: "snow",
                placeholder: 'Escreva algo e compartilhe com seus amigos...',
                modules: {
                    mention: {
                        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                        mentionDenotationChars: ["@"],
                        source: async function(searchTerm, renderList, mentionChar) {
                            let values;
            
                            const response = await api.get(`/api/get_suggestions_web`);
                            const { suggestions } = response.data;
            
                            values = suggestions;
            
                            if (searchTerm.length === 0) {
                                renderList(values, searchTerm);
                            } else {
                            const matches = [];
                            for (let i = 0; i < values.length; i++)
                                if (
                                ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                                )
                                matches.push(values[i]);
                            renderList(matches, searchTerm);
                            }
                        }
                    },
                    toolbar: [
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"],
                        ["clean"],
                    ],
                    clipboard: {
                        matcheVisual: false,
                        matchers: [
                            [
                                Node.TEXT_NODE,
                                (node, delta) => {
                                    const text = node.data;
                                    if (text.match(/(https?:\/\/.*\.(?:png|jpg|jpeg|gif|svg))/i)) {
                                        return { ops: [] };
                                    }
                                    return delta;
                                },
                            ],
                        ],
                    },
                },
            });

            // Impede colagem de imagens
            quillInstance.current.root.addEventListener("paste", (e) => {
                if (e.clipboardData && Array.from(e.clipboardData.items).some(item => item.type.startsWith('image'))) {
                    e.preventDefault();
                    toast.warning('Colar imagens não é permitido.');
                }
            });

            quillInstance.current.on("text-change", () => {
                const editorHTML = quillInstance.current.root.innerHTML;
                const customFormatted = convertMentionsToCustomFormat(editorHTML);

                setText(customFormatted);
                removeImages();
            });
        }
    }, [props.show, editorRef]);


    return (
        <>

            <Modal show={showScheduleModal} onHide={() => setShowScheduleModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Programação do evento</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {schedules.length > 0 && (
                        <div className="mt-3">
                            <ul>
                                {schedules.map((prog, index) => (
                                    <div className="mt-3" key={index}>
                                        <Badge bg="secondary" className="fs-6">{prog.name}</Badge>
                                        <div className="ms-3 mt-2 d-flex gap-4">
                                            <div>
                                                <span className="fw-bold">Início: </span>
                                                {formatScheduleField(prog.data_inicio.split(' ')[0], prog.data_inicio.split(' ')[1])}
                                            </div>
                                            {prog.data_fim && (
                                                <div>
                                                    <span className="fw-bold">Término: </span>
                                                    {formatScheduleField(prog.data_fim.split(' ')[0], prog.data_fim.split(' ')[1])}
                                                </div>
                                            )}
                                        </div>
                                        <div className="ms-3 mt-1">Descrição:<span className="fw-bold ms-1">{prog.descricao}</span></div>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
            </Modal>


            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="lg"
                show={props.show}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h3 className="modal-title" id="share-btnLabel">
                            Compartilhar
                        </h3>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="mt-4">
                    <Row className="gy-3">
                        <Col sm={12} className='special-post'>
                            <div id='post-modal-data' className={`card ${props.class}`}>
                                <div className='card-body pt-2'>
                                    <div className='d-flex align-items-center'>
                                        <form className='post-text w-100'>

                                            <div ref={editorRef} ></div>

                                        </form>
                                    </div>
                                </div>
                                <div className='card card-block card-stretch card-height' style={{ border: '2px solid grey' }}>
                                    <div className='card-body'>
                                        <div className='user-post-data'>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div className='me-3 flex-shrik-0'>
                                                    <img
                                                        className='border border-2 rounded-circle user-post-profile'
                                                        src={share_posts?.user_image || props.user_image}
                                                        alt=''
                                                    />
                                                </div>
                                                <div className='w-100'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <div>
                                                            <h6 className='mb-0 d-inline-block'>{share_posts?.user_name || props.user_name}</h6>{' '}
                                                            {share_posts?.post_time || props.post_time ? (
                                                                <p className='mb-0'>{formatDistanceToNow(parseISO(props.post_time), { addSuffix: true, locale: ptBR })}</p>
                                                            ) : ''}

                                                        </div>

                                                        <div className='card-post-toolbar d-flex'>
                                                            {
                                                                props.new_privacy === 'public' ? (
                                                                    <span className='material-symbols-outlined' style={{ 'marginRight': '10px' }}>
                                                                        public
                                                                    </span>
                                                                ) : props.new_privacy === 'friends' ? (
                                                                    <span className='material-symbols-outlined' style={{ 'marginRight': '10px' }}>
                                                                        group
                                                                    </span>
                                                                ) : ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-4'>

                                                <div>

                                                    {share_posts ? (
                                                        <>

                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: parsePostText(share_posts.text),
                                                                }}
                                                            />

                                                            {share_posts.image && (
                                                                <div className='user-post mt-4 live-container'>
                                                                    <div className='d-flex justify-content-center div-limit-content-inner' style={{ backgroundColor: 'black' }}>
                                                                        <img
                                                                            src={share_posts.image}
                                                                            alt='post-images'
                                                                            className='img-limit-content-inner'
                                                                            loading='lazy'
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {share_posts.video && (
                                                                <div className='user-post mt-4 live-container'>
                                                                    <div className='ratio ratio-16x9' style={{ height: '100%' }}>
                                                                        <div className='d-flex justify-content-center'>
                                                                            <Plyr ref={playerRefShareVideo} {...plyrPropsShare} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {share_posts.live_iframe && (
                                                                <div className=''>
                                                                    <div className='' style={{ height: '100%' }}>
                                                                        <div dangerouslySetInnerHTML={{ __html: share_posts.live_iframe }} style={{ height: '100%' }} />
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {shareMedia.length > 0 && (
                                                                <div>
                                                                    <Slider {...settings}>
                                                                        {shareMedia.map((itemMedia, index) => (
                                                                            <div key={index} >
                                                                                {itemMedia.media_type === 'image' ? (
                                                                                    <img
                                                                                        src={itemMedia.media_url}
                                                                                        alt="post-images"
                                                                                        className='slide-modalShowPost'
                                                                                        loading="lazy"
                                                                                    />
                                                                                ) : itemMedia.media_type === 'video' ? (
                                                                                    <div className="ratio ratio-4x3" style={{ height: '100%' }}>
                                                                                        <div className="d-flex justify-content-center">
                                                                                            <Plyr
                                                                                                style={{ width: '100%' }}
                                                                                                ref={playerRef}
                                                                                                source={{
                                                                                                    type: 'video',
                                                                                                    sources: [{ src: itemMedia.media_url, type: 'video/mp4' }],
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        ))}
                                                                    </Slider>

                                                                    <div className='pageCounterModal'>
                                                                        <p className='pageCounterTextModal'>
                                                                            {currentSlide + 1}/{shareMedia.length}
                                                                        </p>
                                                                    </div>

                                                                    {totalSlides > 1 && (
                                                                        <div className="share-media-slider-dots">
                                                                            {getVisibleIndicators(totalSlides, currentSlide).map((index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    className={`share-media-slider-dot-item ${getIndicatorStyle(
                                                                                        index,
                                                                                        currentSlide
                                                                                    )} ${currentSlide === index ? 'active' : ''}`}
                                                                                >
                                                                                    <button className="share-media-slider-dot-button" />
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </>
                                                    ) : (
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: parsePostText(sanitizedText),
                                                            }}
                                                        />
                                                    )}

                                                    {event_id ? (
                                                        <div className='mt-4'>
                                                            <>
                                                                <h4 className='m-0'>
                                                                    Início: {formatDate(event_start_date)}
                                                                </h4>

                                                                <h4 className='m-0'>
                                                                    Fim: {formatDate(event_end_date)}
                                                                </h4>
                                                            </>

                                                            {
                                                                event_place ? (
                                                                    <div className='mt-3'>
                                                                        <h6 className='m-0'>
                                                                            Local: {event_place}
                                                                        </h6>
                                                                    </div>
                                                                ) : ''
                                                            }

                                                            {
                                                                event_external_link ? (
                                                                    <a target='_blank' href={event_external_link} type='button' className='btn btn-primary px-4 mt-2' style={{ marginRight: '5px' }}>
                                                                        <div className='fw-semibold'>Entrar</div>
                                                                    </a>
                                                                ) : ''
                                                            }

                                                            {
                                                                schedules.length > 0 ? (
                                                                    <button target='_blank' onClick={() => setShowScheduleModal(true)} type='button' className='btn btn-primary px-4 mt-2'>
                                                                        <div className='fw-semibold'>Programação</div>
                                                                    </button>
                                                                ) : ''
                                                            }


                                                        </div>
                                                    ) : ''}


                                                    {pollDetails && Array.isArray(pollDetails.options) && pollDetails.options.length > 0 ? (
                                                        <>
                                                            <div className='d-flex flex-wrap gap-4 mb-5'>
                                                                <div className='d-flex align-items-center gap-2'>
                                                                    <h4>Inicio:</h4>
                                                                    <div className="badge d-flex gap-2 align-items-center text-bg-primary rounded-pill fs-6">
                                                                        <span className="material-symbols-outlined">
                                                                            calendar_month
                                                                        </span>
                                                                        {formattedStartDate.date}

                                                                        <span className="material-symbols-outlined">
                                                                            schedule
                                                                        </span>
                                                                        {formattedStartDate.time}
                                                                    </div>
                                                                </div>

                                                                <div className='d-flex align-items-center gap-2'>
                                                                    <h4>Fim:</h4>

                                                                    <div className="badge d-flex gap-2 align-items-center text-bg-primary rounded-pill fs-6">
                                                                        <span className="material-symbols-outlined">
                                                                            calendar_month
                                                                        </span>
                                                                        {formattedEndDate.date}

                                                                        <span className="material-symbols-outlined">
                                                                            schedule
                                                                        </span>
                                                                        {formattedEndDate.time}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <hr></hr>
                                                            <h4 className='mb-3'>{sanitizedText || 'Enquete'}</h4>
                                                            <Form>
                                                                {pollDetails.options.map((option) => {
                                                                    const percentage = totalVotes
                                                                        ? Math.round((option.votes / totalVotes) * 100)
                                                                        : 0;

                                                                    return (
                                                                        <div key={option.id} className="mb-3">
                                                                            <Form.Check
                                                                                type="radio"
                                                                                label={option.option_text}
                                                                                name="pollOptions"
                                                                                value={option.id}
                                                                                onChange={handleOptionChange}
                                                                                disabled={hasVoted}
                                                                                id={`option-${option.id}`}
                                                                            />
                                                                            <div className='d-flex gap-1'>
                                                                                <ProgressBar
                                                                                    now={percentage}
                                                                                    label={`${percentage.toFixed(2)}%`}
                                                                                    className="my-2 bg-primary-subtle w-100"
                                                                                />
                                                                                <p>{option.votes}</p>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                                <Button
                                                                    onClick={handleVote}
                                                                    disabled={hasVoted || !selectedOption}
                                                                    variant="primary"
                                                                    className='mt-3'
                                                                >
                                                                    {hasVoted ? 'Você já votou' : 'Votar'}
                                                                </Button>
                                                            </Form>
                                                        </>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {live_id && !share_posts ? (
                                                        <div className='user-post mt-4 streaming-container'>
                                                            <div className='ratio ratio-16x9' style={{ height: '100%' }}>
                                                                <div ref={vimeoIframeRef} dangerouslySetInnerHTML={{ __html: live_iframe }} style={{ height: '100%' }} />
                                                            </div>
                                                        </div>
                                                    ) : ''
                                                    }

                                                    {quiz_id ? (

                                                        <Form className='mt-5'>
                                                            {options.map((option, index) => {
                                                                return (
                                                                    <div key={`quiz_option_${index}`} className="mb-3 optionContainer">
                                                                        <Form.Check
                                                                            type="radio"
                                                                            label={option}
                                                                            name="quizOptions"
                                                                            value={option}
                                                                            onChange={(e) => setSelectedQuizOption(e.target.value)}
                                                                            id={`option-${index}`}
                                                                        />
                                                                        <div className='d-flex gap-1'>
                                                                            {
                                                                                option === right_answer && answered ? (<FaCheck style={{ color: 'green' }} />) : option !== right_answer && answered ? (<IoClose style={{ fontSize: '18px', color: 'red' }} />) : ''
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                            <div className='quizAnswerContainer text-center'>
                                                                {
                                                                    answered && isRight ? (
                                                                        <div className="text-success fw-bold">Você acertou! <FaCheck style={{ color: 'green' }} /> </div>
                                                                    ) : answered && !isRight ? (
                                                                        <div className="text-danger fw-bold">Você errou <IoClose style={{ fontSize: '18px', color: 'red' }} /></div>
                                                                    ) : ''
                                                                }

                                                                <button
                                                                    disabled={showSpinnerQuizAnswer || answered}
                                                                    type='button'
                                                                    className='btn btn-primary px-4 mt-3'
                                                                    style={{ marginRight: '5px' }}
                                                                    onClick={() => answerQuestion(selectedQuizOption)}
                                                                >
                                                                    {showSpinnerQuizAnswer ?
                                                                        <div className="spinner-border spinner-border-sm" role="status"></div> :
                                                                        <div className='fw-semibold'>Responder</div>}
                                                                </button>
                                                            </div>
                                                        </Form>

                                                    ) : ''}


                                                </div>

                                            </div>
                                        </div>


                                        {props.new_type === 'image' ? (
                                            <div className='user-post mt-4 live-container'>
                                                <div className='ratio ratio-16x9' style={{ height: '100%' }}>
                                                    <img
                                                        src={props.new_media}
                                                        alt='post-images'
                                                        className='img-fluid rounded w-100'
                                                        loading='lazy'
                                                    />
                                                </div>
                                            </div>
                                        ) : props.new_type === 'video' ? (
                                            <div className='user-post mt-4 live-container'>
                                                <div className='ratio ratio-16x9' style={{ height: '100%' }}>
                                                    <div className='d-flex'>
                                                        <Plyr ref={playerRef} {...plyrProps} />
                                                    </div>
                                                </div>
                                            </div>

                                        ) : props.live_iframe && !share_posts ? (
                                            <div className=''>
                                                <div className='' style={{ height: '100%' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: props.live_iframe }} style={{ height: '100%' }} />
                                                </div>
                                            </div>
                                        ) : medias.length > 0 ? (
                                            <div>
                                                <Slider {...settings}>
                                                    {medias.map((itemMedia, index) => (
                                                        <div key={index} >
                                                            {itemMedia.media_type === 'image' ? (
                                                                <img
                                                                    src={itemMedia.media_url}
                                                                    alt="post-images"
                                                                    className='slide-modalShowPost'
                                                                    loading="lazy"
                                                                />
                                                            ) : itemMedia.media_type === 'video' ? (
                                                                <div className="ratio ratio-4x3" style={{ height: '100%' }}>
                                                                    <div className="d-flex justify-content-center">
                                                                        <Plyr
                                                                            style={{ width: '100%' }}
                                                                            ref={playerRef}
                                                                            source={{
                                                                                type: 'video',
                                                                                sources: [{ src: itemMedia.media_url, type: 'video/mp4' }],
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    ))}
                                                </Slider>

                                                <div className='pageCounterModal'>
                                                    <p className='pageCounterTextModal'>
                                                        {currentSlide + 1}/{medias.length}
                                                    </p>
                                                </div>

                                                {totalSlides > 1 && (
                                                    <div className="share-media-slider-dots">
                                                        {getVisibleIndicators(totalSlides, currentSlide).map((index) => (
                                                            <div
                                                                key={index}
                                                                className={`share-media-slider-dot-item ${getIndicatorStyle(
                                                                    index,
                                                                    currentSlide
                                                                )} ${currentSlide === index ? 'active' : ''}`}
                                                            >
                                                                <button className="share-media-slider-dot-button" />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ) : ''
                                        }
                                    </div>
                                </div>
                                <div className='card-body bg-primary-subtle rounded-bottom-3'>
                                    <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
                                        <div className='create-post-data'>
                                            <ul className='list-inline m-0 p-0 d-flex align-items-center gap-4'>
                                                {
                                                    !props.group_id ? (
                                                        <li className="icon-item">
                                                            <Dropdown>
                                                                <Dropdown.Toggle id='post-option' as='span' >
                                                                    {
                                                                        privacy === 'public' ? (
                                                                            <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                                                                public
                                                                            </span>
                                                                        ) : privacy === 'friends' ? (
                                                                            <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                                                                group
                                                                            </span>
                                                                        ) : ''
                                                                    }
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='m-0 p-0'>
                                                                    <Dropdown.Item className=' p-3' to='#' onClick={() => setPrivacy('public')}>
                                                                        <div className='d-flex align-items-top'>
                                                                            <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                                                                public
                                                                            </span>
                                                                            <div className='data ms-2'>
                                                                                <h6>pública</h6>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>

                                                                    <Dropdown.Item className=' p-3' to='#' onClick={() => setPrivacy('friends')}>
                                                                        <div className='d-flex align-items-top'>
                                                                            <span className='material-symbols-outlined' style={{ 'fontSize': 'large', 'verticalAlign': 'middle' }}>
                                                                                group
                                                                            </span>
                                                                            <div className='data ms-2'>
                                                                                <h6>amigos</h6>
                                                                            </div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </li>
                                                    ) : ''
                                                }
                                            </ul>

                                        </div>
                                        <div>
                                            <ul className='list-inline m-0 p-0 d-flex align-items-center gap-4'>
                                                <li>
                                                    <button disabled={showSpinner} type='button' className='btn btn-primary px-4' onClick={(e) => handleSubmit(e)}>
                                                        {showSpinner ? <div className="spinner-border spinner-border-sm" role="status"></div> : <div className='fw-semibold'>Publicar</div>}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default ShareOffcanvasNew;
